import Modal from '@/components/common/Modal'
import { PremiumText } from '@/components/Premium/PremiumStyled'
import ButtonIcon from '@/components/common/ButtonIcon'
import styled from 'styled-components'
import Row from '@/components/common/Row'
import Button from '@/components/ui/Button'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { close } from '@/store/modalsSlice'
import { device } from '@/common/constants/device'
import Text from '@/components/common/Text'
import BaseLink from '@/components/common/BaseLink'
import { userAmplitudeAnalytics } from '@/common/services/userAmplitudeAnalytics'
import { ANALYTIC_OFFER } from '@/common/constants/analytics'
import { PAYMENT_SOURCE } from '@/common/constants/cookies'
import { useTranslations } from 'next-intl'

const CreativesLimitBlock = styled.div`
  padding: 0 16px;

  @media ${device.tablet} {
    padding: 0 24px;
  }

  .premium-modal-email {
    margin-bottom: 16px;
  }
`
const CreativesLimitContent = styled.div`
  position: relative;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  width: 100%;
`

const CreativesLimitWrap = styled(Modal)`
  .modal-content {
    width: calc(100% - 30px);

    @media ${device.tablet} {
      width: 100%;
    }
  }
`

const CreativesLimitTop = styled(Row)`
  justify-content: space-between;
  column-gap: 12px;
  padding: 0 16px;

  @media ${device.tablet} {
    padding: 0 24px;
    align-items: center;
  }
`

const CreativesLimitTitle = styled(PremiumText)`
  color: var(--black-russian);
`

const CreativesLimitDescription = styled(Text)``

const CreativesLimitClose = styled(ButtonIcon)`
  width: 24px;
  height: 24px;
  cursor: pointer;
  background-color: var(--tertiary);
  transition: transform 0.26s ease-in-out;
  flex-shrink: 0;

  &:hover {
    transform: rotate(90deg);
  }

  @media ${device.tablet} {
    width: 32px;
    height: 32px;
  }
`

const CreativesLimitButton = styled(Button)`
  width: 100%;
  margin-top: 24px;
`

const CreativesLimitModal = () => {
  const t = useTranslations('common')
  const dispatch = useDispatch()

  const closeModal = () => {
    dispatch(close())
    userAmplitudeAnalytics.trackEvent(
      `${ANALYTIC_OFFER}_collapse_banner_close_clicked`,
      {
        trigger: 'search',
      }
    )
  }

  const onSubscription = () => {
    userAmplitudeAnalytics.trackEvent(
      `${ANALYTIC_OFFER}_collapse_banner_cta_clicked`,
      {
        trigger: 'search',
      }
    )
    sessionStorage.setItem(PAYMENT_SOURCE, 'search')
  }

  useEffect(() => {
    userAmplitudeAnalytics.trackEvent(
      `${ANALYTIC_OFFER}_collapse_banner_shown`,
      {
        trigger: 'search',
      }
    )
  }, [])

  return (
    <CreativesLimitWrap maxWidth="644" needOffsetHeader onClose={closeModal}>
      <CreativesLimitContent>
        <CreativesLimitTop>
          <CreativesLimitTitle>{t('limitTitle')}</CreativesLimitTitle>
          <CreativesLimitClose onClick={closeModal} icon="cross" />
        </CreativesLimitTop>
        <CreativesLimitBlock>
          <CreativesLimitDescription color="grey">
            {t('limitDescription')}
          </CreativesLimitDescription>
          <BaseLink href="/premium" isChangePath={false}>
            <CreativesLimitButton type="button" filled onClick={onSubscription}>
              {t('headerSubscriptionPurchaseButton')}
            </CreativesLimitButton>
          </BaseLink>
        </CreativesLimitBlock>
      </CreativesLimitContent>
    </CreativesLimitWrap>
  )
}

export default CreativesLimitModal
